import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query'

import type { CustomError } from '@front/type/api'

import { axiosPost } from '../logic/axios/wrappers/axios.post.wrapper'

import { adminShiftUrl } from './config'

export const useRequestAgenciesMutation = (
  options?: UseMutationOptions<void, CustomError, number>,
): UseMutationResult<void, CustomError, number> => {
  return useMutation({
    mutationFn: (idShift: number) =>
      axiosPost<void>(
        `${adminShiftUrl}/${idShift}/agencies/requests/request`,
        {},
      ),
    ...options,
  })
}
